import React from 'react';
import {
  Col, 
  Row,
  Card,
  CardBody,
  CardHeader,
} from 'reactstrap';
import { useSelector } from 'react-redux';
import PatientPracticeDropdown from './PatientPracticeDropdown';

const PatientExtRefForm = ({ userData }) => {

  const patientData = useSelector(state => state.usersPatientsReducer.fullData);

  if (!Object.keys(patientData).length) {
    return <></>;
  }

  return (
    <Card>
        <CardHeader>
            {`${userData?.firstName} ${userData?.lastName} Patient info`}
        </CardHeader>
        <CardBody>
            <Row>

              <Col sm="4">
                <div className="user-info-card">
                  <div className="user-info-card-title">
                    Auth Patient Database Info
                  </div>
                  <div className="user-info-card-content-section">
                    {Object.keys(patientData.auth).map(d => {
                      if (d === "__v" || d === "_id") return <></>
                      return <>
                        <div className="user-info-card-content">
                          <span>{d}:</span> <span>{String(patientData.auth[d])}</span>
                        </div>
                      </>
                    })}
                  </div>
                </div>
              </Col>

              <Col sm="4">
                <div className="user-info-card">
                  <div className="user-info-card-title">
                    Users Database Info
                  </div>
                  <div className="user-info-card-content-section">
                    {Object.keys(patientData.userData).map(d => {
                      if (d === "__v" || d === "_id") return <></>
                      return <>
                        <div className="user-info-card-content">
                          <span>{d}:</span> <span>{String(patientData.userData[d])}</span>
                        </div>
                      </>
                    })}
                  </div>
                </div>
              </Col>

              <Col sm="4">
                <div className="user-info-card">
                  <div className="user-info-card-title">
                    PatientsUsers Database Info
                  </div>

                  <div className="user-info-card-content-section">
                    {Object.keys(patientData.profile).map(d => {
                      if (d === "__v" || d === "_id") return <></>

                      if (d === "practices") {
                        return <div>
                          <span style={{fontWeight:"bold"}}>{d}:</span> {patientData.profile[d].map(pr => <PatientPracticeDropdown practice={pr}/>)}
                        </div>
                      }
                      return <>
                        <div className="user-info-card-content">
                          <span>{d}:</span> <span>{String(patientData.profile[d])}</span>
                        </div>
                      </>
                    })}
                  </div>
                </div>
              </Col>
            </Row>
                    
            {patientData.anomalies.length ? (
              <Row>
                <Col>
                  <div className="user-error-card">
                      <div className="user-error-card-title">
                        Detected Anomalies
                      </div>
                      <div className="user-error-card-content-section">
                        {patientData.anomalies.map(d => {
                          return (
                            <div className="user-error-card-content">
                              <div>Code: {d.code}</div>
                              <div>Description: {d.message}</div>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                </Col>
              </Row>
            ) : (<></>)}

        </CardBody>
    </Card>
  );
};

export default PatientExtRefForm;